export default __webpack_public_path__ + "static/media/refresh.c0a55c1b.svg";